import React, { useState } from "react";
import { CubeIcon } from "@heroicons/react/24/outline";
import { PresalesListTable } from "./PresalesListTable";
import { CheckoutButton } from "./CheckoutButton";
import { AcceptTerms } from "./AcceptTerms";
import { formatNumberWithSeparator } from "../../Hooks/UseGenericFunctions";
import {axiosInstance} from "../../Api/AxiosConfig";

export const PackageList = ({ packages, equipmentIcons, carHash, fnUpdateCarList }) => {
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [orderCheckoutPending, setOrderCheckoutPending] = useState(false);
    const [setCurrentError] = useState(null);

    const placeOrder = (carPackage) => {
        if (termsAccepted && !orderCheckoutPending) {
            axiosInstance
                .post(carPackage.accept_url)

                .then((response) => {
                    setOrderCheckoutPending(false);
                    if (response.status === 200 && response.data.error === false) {
                        setTermsAccepted(false);
                        setCurrentError(null);
                        fnUpdateCarList();
                    }
                    if (response.status === 200 && response.data.error === true) {
                        setCurrentError(response.data.messages);
                    }
                })

                .catch((error) => {
                    setOrderCheckoutPending(false);
                    console.error("Error fetching data:", error);
                });
        }
        setOrderCheckoutPending(true);
    }

    return (
        <div className={`h-[92vh] overflow-y-auto`} style={{ height: 'calc(92vh - 80px)' }}>
            {packages.list.map((carPackage, index) => {
                return (
                    <div key={'package_' + index} className="bg-white p-6 mb-4 rounded-xl">
                        {packages.list.length > 1 &&
                            <div className="text-2xl flex items-center font-bold mb-4 py-2 ml-6 border-b border-b-gray-400 w-fit uppercase">
                                <div className="mr-2 rounded-full bg-gray-200 p-2">
                                    <CubeIcon className="text-gray-500 w-8 h-8" />
                                </div>
                                <div>{carPackage.name}</div>
                            </div>
                        }
                        <div className="ml-6">
                            <PresalesListTable
                                cars={carPackage.cars}
                                useNaturalScrolling={true}
                                hidePrices={true}
                                equipmentIcons={equipmentIcons}
                                activeCarId={carHash}
                                activeSortField={""}
                                activeSortAscending={""}
                                fnSetSortByField={() => { return }}
                                fnSetSortByFieldOrder={() => { return }}
                                fnUpdateCarList={fnUpdateCarList}
                                tableConfiguration="package"
                            />
                            <div className="mt-5 p-4 rounded bg-white flex items-start justify-between border-t">
                                <div className="relative flex flex-col gap-2">
                                    <div className="text-sm rounded-xl bg-green-100 px-2 py-1 w-fit">
                                        Discount:&nbsp;&nbsp;
                                        <span className="font-bold">
                                            -{formatNumberWithSeparator(Number(carPackage.total_discount), ".")}&nbsp;{carPackage.currency}
                                        </span>
                                    </div>
                                    <div className="flex items-center">
                                        <div className="font-bold text-2xl ml-2">
                                            {formatNumberWithSeparator(Number(carPackage.total_price), ".")}&nbsp;{carPackage.currency}
                                        </div>
                                        <div className="text-xs rounded-xl py-1 px-2 bg-gray-200 ml-2">Package Price</div>
                                    </div>
                                </div>
                                <div className="flex items-end flex-col gap-2">
                                    <CheckoutButton
                                        text={'Purchase ' + carPackage.cars.length + ' cars'}
                                        onClick={() => placeOrder(carPackage)}
                                        disabled={!termsAccepted}
                                    />
                                    <AcceptTerms
                                        key={`accept-terms-${index}`}
                                        termsAccepted={termsAccepted}
                                        setTermsAccepted={setTermsAccepted}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
